"use strict";function openSlidePanel$(e){return ddSdk_1.ddSdk.invokeAPI(apiName,e)}var _a;Object.defineProperty(exports,"__esModule",{value:!0}),exports.openSlidePanel$=void 0;var ddSdk_1=require("../../../lib/ddSdk"),apiName="biz.util.openSlidePanel";ddSdk_1.ddSdk.setAPI(apiName,(_a={},_a[ddSdk_1.ENV_ENUM.pc]={vs:"2.5.0"},_a)),exports.openSlidePanel$=openSlidePanel$,exports.default=openSlidePanel$;


//////////////////
// WEBPACK FOOTER
// ./~/_dingtalk-jsapi@2.13.71@dingtalk-jsapi/api/biz/util/openSlidePanel.js
// module id = 1017
// module chunks = 106